import { defineChain } from 'viem';

export const lazaiTestnet = defineChain({
    id: 133718,
    name: 'LazAI Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'LazAI Testnet',
        symbol: 'LAZAI',
    },
    rpcUrls: {
        default: {
            http: ['https://testnet.lazai.network'],
            webSocket: ['https://testnet.lazai.network'],
        },
        public: {
            http: ['https://testnet.lazai.network'],
            webSocket: ['https://testnet.lazai.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LazAI Testnet Explorer',
            url: 'https://testnet-explorer.lazai.network',
        },
    },
});
